import { render, staticRenderFns } from "./MainBtn.vue?vue&type=template&id=5e0d43f6&scoped=true&"
import script from "./MainBtn.vue?vue&type=script&lang=ts&"
export * from "./MainBtn.vue?vue&type=script&lang=ts&"
import style0 from "./MainBtn.vue?vue&type=style&index=0&id=5e0d43f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d43f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
